export const BACKGROUND_FILTER_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 640,
  height: 480,
  frameRate: 24,
};

export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = 'TwilioVideoApp-selectedAudioInput';
export const SELECTED_AUDIO_OUTPUT_KEY = 'TwilioVideoApp-selectedAudioOutput';
export const SELECTED_VIDEO_INPUT_KEY = 'TwilioVideoApp-selectedVideoInput';

// This is used to store the current background settings in localStorage
export const SELECTED_BACKGROUND_SETTINGS_KEY = 'TwilioVideoApp-selectedBackgroundSettings';

export const GALLERY_VIEW_ASPECT_RATIO = 9 / 16; // 16:9
export const GALLERY_VIEW_MARGIN = 3;

// avatara's main root variations
export const ROOT_URL = 'collaborate.avataracloud.com';
export const ROOT_API_URL = 'https://collaborate.avataracloud.com';
export const ROOT_API_URL2 = 'https://ccconnect.avataracloud.com';
export const ROOT_API_URL3 = 'https://cccrm.avataracloud.com';
export const ROOT_API_URL4 = 'https://apidev.avataracloud.com';
export const ROOT_FILE_API_URL = 'https://connect.avataracloud.com';

// api paths
const { origin: locationOrigin, protocol, hostname } = window.location;
const localhostApiUrl = `${protocol}//${hostname}:8081`;
const isDev = locationOrigin.includes('localhost');
export const API_VIDEO_TOKEN = `${isDev ? localhostApiUrl : locationOrigin}/api/token/videotoken`;
export const API_UPDATE_VIDEO_RECORDINGRULES = `${isDev ? localhostApiUrl : locationOrigin}/api/room/recordingrules`;
export const API_VOICE_TOKEN = `${isDev ? localhostApiUrl : locationOrigin}/api/token/voicetoken`;
// export const API_VOICE_TOKEN = `http://localhost:8081/voicetoken`;
export const API_GET_CONTACTS = `${ROOT_API_URL2}/api/ExchangeContactsSearch`;
export const API_SEND_MAIL = `${ROOT_API_URL2}/api/SendMeetInviteEmail`;
export const API_SEND_SMS = `${ROOT_API_URL2}/api/SendSMSMessage`;
export const API_GET_PHONENUMBER = `${ROOT_API_URL3}/adminsite3`;
export const API_GET_ACTIVE_ROOMS = `${ROOT_API_URL2}/api/GetCCMeetRoomsForUser`;
export const API_GET_ROOM_CONFIG = `${ROOT_API_URL2}/api/GetMyCCMeetRoomConfig`;
export const API_SET_ROOM_PRIVACY = `${ROOT_API_URL2}/api/UpdateCCMeetRoomPrivacy`;
export const API_KNOCK_USER_ROOM = `${ROOT_API_URL2}/api/KnockAtCCMeetRoom`;
export const API_ACKNOWLEDGE_KNOCK = `${ROOT_API_URL2}/api/RespondToCCMeetKnock`;
export const API_GET_KNOCK_STATUS = `${ROOT_API_URL2}/api/GetKnockStatus`;
export const API_CLEAR_KNOCK = `${ROOT_API_URL2}/api/ClearCCMeetKnock`;
export const API_GET_ROOM_KNOCKS = `${ROOT_API_URL2}/api/GetKnocksAtCCMeetRoom`;
export const API_GET_ROOM_DID = `${ROOT_API_URL2}/api/PersonFromUPN`;
export const API_GET_USER_DETAILS = `${ROOT_API_URL2}/api/GetPersonFromUsername`;
export const API_ROOM = `${isDev ? localhostApiUrl : locationOrigin}/api/room`;
export const API_ROOM_GETALLBYSTATUS = `${isDev ? localhostApiUrl : locationOrigin}/api/room/list`;
export const API_CREATE_MEETING = `${ROOT_API_URL2}/api/CreateScheduledMeeting`;
export const API_GET_ALL_MEETINGS = `${ROOT_API_URL2}/api/GetScheduledMeetingsByFromUPN`;
export const API_GET_MEETING = `${ROOT_API_URL2}/api/GetScheduledMeetingsByMeetingID`;
export const API_UPDATE_MEETING_STATUS = `${ROOT_API_URL2}/api/UpdateCCMeetMeetingStatus`;
export const API_GET_EXTENSION = `${ROOT_API_URL2}/api/PhoneConfigBySipPhone`;
export const API_GET_PERSON_ID = `${ROOT_API_URL2}/api/DomainUser`;
export const API_GET_FIRST_NAME = `${ROOT_API_URL2}/api/PersonFromPersonID`;

// Chat API Endpoints
export const API_GET_CHAT_MESSAGES = `${
  isDev ? localhostApiUrl : locationOrigin
}/api/room/chat-room/%roomname%/messages`;
export const API_SEND_CHAT_MESSAGE = `${isDev ? localhostApiUrl : locationOrigin}/api/room/chat-room/message`;
export const API_JOIN_ROOM_CHAT = `${isDev ? localhostApiUrl : locationOrigin}/api/room/chat-room/join`;

// File API paths
export const API_FILE_GET = `${isDev ? localhostApiUrl : locationOrigin}/api/files/get`;
export const API_FILE_AUTH = `${isDev ? localhostApiUrl : locationOrigin}/api/files/auth`;
export const API_FILE_CREATE = `${isDev ? localhostApiUrl : locationOrigin}/api/files/create`;
export const API_FILE_DELETE = `${isDev ? localhostApiUrl : locationOrigin}/api/files`;
export const API_FILE_UPLOAD = `${isDev ? localhostApiUrl : locationOrigin}/api/files/upload`;
export const API_FILE_DOWNLOAD = `${isDev ? localhostApiUrl : locationOrigin}/api/files/download`;
export const API_FILE_IMAGE = `${isDev ? localhostApiUrl : locationOrigin}/api/files/getfsslideimage`;
export const API_FILE_PDF = `${isDev ? localhostApiUrl : locationOrigin}/api/files/docconvert`;
export const API_FILE_WOPI_URL = `${isDev ? localhostApiUrl : locationOrigin}/api/files/getwopiviewurl`;

// generic api token for authorization
export const API_TOKEN = '53t1FbIRuRfi2QeSvYVt2z3pxeljVxjf';
// default countries from twilio
export const countries = [
  { name: 'United States', cc: '1', code: 'us' },
  { name: 'Great Britain', cc: '44', code: 'gb' },
  { name: 'Colombia', cc: '57', code: 'co' },
  { name: 'Ecuador', cc: '593', code: 'ec' },
  { name: 'Estonia', cc: '372', code: 'ee' },
  { name: 'Germany', cc: '49', code: 'de' },
  { name: 'Hong Kong', cc: '852', code: 'hk' },
  { name: 'Ireland', cc: '353', code: 'ie' },
  { name: 'Singapore', cc: '65', code: 'sg' },
  { name: 'Spain', cc: '34', code: 'es' },
  { name: 'Brazil', cc: '55', code: 'br' },
];
// list of numbers and letters for CCVoice Manual DialPad
export const numbers = [
  { num: '1', alphabets: '' },
  { num: '2', alphabets: 'ABC' },
  { num: '3', alphabets: 'DEF' },
  { num: '4', alphabets: 'GHI' },
  { num: '5', alphabets: 'JKL' },
  { num: '6', alphabets: 'MNO' },
  { num: '7', alphabets: 'PQRS' },
  { num: '8', alphabets: 'TUV' },
  { num: '9', alphabets: 'WXYZ' },
  { num: '*', alphabets: '' },
  { num: '0', alphabets: '' },
  { num: '#', alphabets: '' },
];

export const MESSAGE_EVENTS = {
  KICK: 'KICK',
  REMOVE_AUDIO: 'REMOVE_AUDIO',
};
